import React from 'react';
import { Box, Spinner } from '@chakra-ui/react';

const LoadingSpinner = ({ minHeight = "200px" }) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight={minHeight}>
      <Spinner size="xl" color="theme.teal" />
    </Box>
  );
};

export default LoadingSpinner;
